<template>
  <div class="form-group row">
      <div class="col-sm-12">
          <FormButton :class="['btn', buttonCancelClass, buttonSizeClass, 'm-r']" type="button" @click.prevent="onCancelled">Cancel</FormButton>
          <FormButton :class="['btn', buttonSubmitClass, buttonSizeClass]" type="button" :loading="submitting" @click.prevent="onSubmitted" :disabled="disabled">{{label}}</FormButton>
      </div>
  </div>
</template>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormSubmitButton",
  mixins: [formField],
  props: {
    label: String,
    submitting: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonSizeClass: {
      type: String,
      default: 'btn-sm'
    },
    buttonCancelClass: {
      type: String,
      default: 'btn-default'
    },
    buttonSubmitClass: {
      type: String,
      default: 'btn-primary'
    }
  },
  methods: {
    onSubmitted(evt) {
      this.$emit('submitted', evt)
    },
    onCancelled(evt) {
      this.$emit('cancelled', evt)
    }
  }
};
</script>